// extracted by mini-css-extract-plugin
export default {"usersTable":"Dashboard_usersTable__XQ427"};